var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBlueBlob(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60vh",
    height: "40vh",
    viewBox: "0 0 600 600",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(300,300)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.4,-58.1C224.6,6,182,98.9,113,146.9C44.1,195,-51.1,198.2,-106.1,156C-161,113.7,-175.6,25.9,-151.2,-39.8C-126.8,-105.5,-63.4,-149.3,12.8,-153.4C89.1,-157.6,178.2,-122.2,201.4,-58.1Z",
    fill: "#ADDADB"
  }))));
}

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/Pgo8c3ZnCiAgd2lkdGg9IjYwdmgiCiAgaGVpZ2h0PSI0MHZoIgogIHZpZXdCb3g9IjAgMCA2MDAgNjAwIgogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKPgogIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDMwMCwzMDApIj4KICAgIDxwYXRoIGQ9Ik0yMDEuNCwtNTguMUMyMjQuNiw2LDE4Miw5OC45LDExMywxNDYuOUM0NC4xLDE5NSwtNTEuMSwxOTguMiwtMTA2LjEsMTU2Qy0xNjEsMTEzLjcsLTE3NS42LDI1LjksLTE1MS4yLC0zOS44Qy0xMjYuOCwtMTA1LjUsLTYzLjQsLTE0OS4zLDEyLjgsLTE1My40Qzg5LjEsLTE1Ny42LDE3OC4yLC0xMjIuMiwyMDEuNCwtNTguMVoiIGZpbGw9IiNBRERBREIiIC8+CiAgPC9nPgo8L3N2Zz4KICA=";
export { SvgBlueBlob as ReactComponent };